import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveGeoGroupsMutationVariables = Types.Exact<{
  geoGroups: ReadonlyArray<Types.YalperGeoGroupInput> | Types.YalperGeoGroupInput;
}>;


export type SaveGeoGroupsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveGeoGroups: boolean };


export const SaveGeoGroupsDocument = gql`
    mutation SaveGeoGroups($geoGroups: [YalperGeoGroupInput!]!) {
  saveGeoGroups(geoGroups: $geoGroups)
}
    `;
export type SaveGeoGroupsMutationFn = Apollo.MutationFunction<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>;

/**
 * __useSaveGeoGroupsMutation__
 *
 * To run a mutation, you first call `useSaveGeoGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveGeoGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveGeoGroupsMutation, { data, loading, error }] = useSaveGeoGroupsMutation({
 *   variables: {
 *      geoGroups: // value for 'geoGroups'
 *   },
 * });
 */
export function useSaveGeoGroupsMutation(baseOptions?: Apollo.MutationHookOptions<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>(SaveGeoGroupsDocument, options);
      }
export type SaveGeoGroupsMutationHookResult = ReturnType<typeof useSaveGeoGroupsMutation>;
export type SaveGeoGroupsMutationResult = Apollo.MutationResult<SaveGeoGroupsMutationPage>;
export type SaveGeoGroupsMutationOptions = Apollo.BaseMutationOptions<SaveGeoGroupsMutationPage, SaveGeoGroupsMutationVariables>;